import type { TimeZone } from '@vvo/tzdb';
import { getTimeZones } from '@vvo/tzdb';


export const timezones: { [k: TimeZone['name']]: TimeZone } = {};

for (const tz of getTimeZones()) timezones[tz.name] = tz;
